import React from 'react'
import { Formik } from 'formik'
import { UseMutateContractByIdReturn, ContractNotesByIdDocument, useMutateContractById, useContractNotesById } from 'src/queries'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import { MutateContractByIdMutation } from 'src/gql/graphql'
import Form from './Form'
import parsePlainText from 'src/helpers/parsePlainText'

type Values = Parameters<UseMutateContractByIdReturn['mutate']>[0]['record']

interface FormContextProps {
  id: string
  toggle: () => void
}

const FormContext: React.FC<FormContextProps> = (props) => {
  const { id, toggle } = props
  const Contract = useContractNotesById(id)
  if (Contract === undefined) {
    throw new Error('Could not load Contract!')
  }
  const update = useMutateContractById()
  let notes = Contract.notes ?? ''
  notes = parsePlainText(notes)
  const initialState: Values = {
    notes
  }
  const invalidateContract = useInvalidateQueryByDocument(ContractNotesByIdDocument)
  const handleSuccess = (data: MutateContractByIdMutation): void => {
    const id = data.cat?.contract?.updateById?.recordId
    if (typeof id === 'string') {
      void invalidateContract({ id })
    }
    toggle()
  }
  return (
    <Formik
      initialValues={initialState}
      onSubmit={async (data) => {
        const record = { ...data }
        update.mutate({ id, record }, { onSuccess: handleSuccess })
      }}
    >
      {(props) => (
        <>
          <Form toggle={toggle} isLoading={update.isLoading} hasError={update.isError} />
        </>
      )}
    </Formik>
  )
}

export default FormContext
